import type { ReactElement } from 'react'

import Plugin from '../../templateComponents/Plugin'

export default function Legal(props): ReactElement {
  return (
    <div className="legal">
      <section className="section">
        <div className="wrapper">
          <div className="content">
            <Plugin type="epages.text" _id="legal-content" key={props.page.id} />
          </div>
        </div>
      </section>
    </div>
  )
}
